import React from 'react';
import { Box, Skeleton } from '@mui/material';

const IconicRideCardSkeleton = () => (
  <Box>
    <Skeleton variant="rounded" width="100%" height={450} />
    <Skeleton variant="text" width="80%" height={50} sx={{ marginTop: 1 }} />
  </Box>
);

export { IconicRideCardSkeleton };
